import Vue from 'vue';
import Vuex from 'vuex';
import workflowData from '../../public/data.json';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    workflows: [], // Stores all workflows before filtering
    selectedWorkflow: null, // Stores the currently selected workflow
    isMoreThanOneNodeChecked: false,
    isAtLeastTwoPrimaryChecked: false,
    isAtLeastOneTaskChecked: false
  },
  mutations: {
    SET_WORKFLOWS(state, workflows) {
      state.workflows = workflows; // Store the workflows
    },
    SET_SELECTED_WORKFLOW(state, workflow) {
      state.selectedWorkflow = workflow;
    },
    TOGGLE_MORE_THAN_ONE_NODE(state, isChecked) {
      state.isMoreThanOneNodeChecked = isChecked;
    },
    TOGGLE_AT_LEAST_TWO_PRIMARY(state, isChecked) {
      state.isAtLeastTwoPrimaryChecked = isChecked;
    },
    TOGGLE_AT_LEAST_ONE_TASK(state, isChecked) {
      state.isAtLeastOneTaskChecked = isChecked;
    }
  },
  actions: {
    async fetchWorkflows({ commit }) {
      try {
        const response = workflowData;
        commit('SET_WORKFLOWS', response);
        if (response.length > 0) {
          commit('SET_SELECTED_WORKFLOW', response[0]);
        }
      } catch (error) {
        console.error('Error fetching workflow data:', error);
      }
    },
    selectWorkflow({ commit, state }, workflow) {
      if (typeof workflow === "object"){
        commit("SET_SELECTED_WORKFLOW", workflow);
      }else{
        const workflow1 = state.workflows.find(wf => wf.title === workflow);
        commit('SET_SELECTED_WORKFLOW', workflow1);
      }
      
    },
    toggleMoreThanOneNode({ commit }, isChecked) {
      commit('TOGGLE_MORE_THAN_ONE_NODE', isChecked);
    },
    toggleAtLeastTwoPrimary({ commit }, isChecked) {
      commit('TOGGLE_AT_LEAST_TWO_PRIMARY', isChecked);
    },
    toggleAtLeastOneTask({ commit }, isChecked) {
      commit('TOGGLE_AT_LEAST_ONE_TASK', isChecked);
    }
  },
  getters: {
    getFilteredWorkflows: state => {
      let filteredWorkflows = [...state.workflows];

      // Apply filters based on checkboxes
      if (state.isMoreThanOneNodeChecked) {
        filteredWorkflows = filteredWorkflows.filter(item => item.workflowData.nodes.length > 1);
      }
      if (state.isAtLeastTwoPrimaryChecked) {
        filteredWorkflows = filteredWorkflows.filter(item => {
          const primaryCount = item.workflowData.nodes.filter(edge => edge.type === "dataset").length;
          return primaryCount >= 2;
        });
      }
      if (state.isAtLeastOneTaskChecked) {
        filteredWorkflows = filteredWorkflows.filter(item => {
          return item.workflowData.nodes.some(node => node.type === "dataview" && node.properties.no_of_tasks > 0);
        });
      }
      

      return filteredWorkflows;
    },
    getWorkflowTitles: state => state.workflows.map(wf => ({ title: wf.title })),
    getSelectedWorkflow: state => state.selectedWorkflow
  }
});
